import React from 'react';
import { IconProps } from './types';

const NewArrowRight: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181B32',
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 13L16.865 13L13.232 17.36C12.878 17.784 12.936 18.415 13.36 18.768C13.785 19.122 14.415 19.064 14.768 18.64L19.768 12.64C19.807 12.593 19.827 12.538 19.856 12.486C19.88 12.444 19.909 12.408 19.927 12.362C19.972 12.247 19.999 12.126 19.999 12.004C19.999 12.003 20 12.001 20 12C20 11.999 19.999 11.997 19.999 11.996C19.999 11.874 19.972 11.753 19.927 11.638C19.909 11.592 19.88 11.556 19.856 11.514C19.827 11.462 19.807 11.407 19.768 11.36L14.768 5.36C14.57 5.123 14.286 5 14 5C13.774 5 13.547 5.076 13.36 5.232C12.936 5.585 12.878 6.216 13.232 6.64L16.865 11L5 11C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default NewArrowRight;
